import { t } from 'i18next';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { getTenantInfoByKey } from '../../../helpers/helpers';

export const BuildingSearcher = ({ handleChangeSearchText }) => {
    const navigate = useNavigate();
    const nameOfBuildings = getTenantInfoByKey('building_name');

    return (
        <>
            <div className='mt-2 mb-2'>
                <input
                    placeholder={t('SEARCH')}
                    type={"text"}
                    name={'searchBuildings'}
                    className="form-control access-input"
                    autoComplete='off'
                    onChange={(e) => handleChangeSearchText(e.target.value)}
                />
            </div>

            <div className='text-end mt-3 mb-3'>
                <p style={{ fontWeight: '600', fontSize: '16px', lineHeight: '19px', display: 'inline' }}
                    className='m-0 me-1 gray-950-color'
                    onClick={() => navigate('/settings/entityManagment/buildingsMaganagement/create')}
                    type="button"
                >
                    {`+ ${t('CREATE')} ${nameOfBuildings}`}
                </p>
            </div>
        </>
    )
}
